module.exports = __webpack_public_path__ + "img/F960.34d530ba.jpg";